import type { Recipe } from '@awwyeah/shared';
import { Link } from 'react-router-dom';
import { RecipePhoto } from './RecipePhoto';

export interface RecipeCardProps {
  recipe: Recipe;
}

/** Grid card for the recipe box browse view (Screen E · 14). A recipe with a photo shows
 * its ~480px thumb; one without gets the code-computed emoji-on-gradient placeholder
 * (WS-20, `utils/placeholderArt.ts`) instead of a generic icon. */
export function RecipeCard({ recipe }: RecipeCardProps): JSX.Element {
  return (
    <Link
      to={`/recipes/${recipe.id}`}
      data-testid="recipe-card"
      className="flex flex-col overflow-hidden rounded-md border border-line bg-surface text-left ease-app hover:border-line-strong"
    >
      <RecipePhoto recipe={recipe} alt={recipe.title} variant="thumb" className="h-24" />
      <div className="flex flex-col gap-0.5 border-t border-line px-3 py-2.5">
        <span className="truncate text-[15px] font-semibold text-fg">{recipe.title}</span>
        <span className="truncate text-xs text-fg-3">
          {[recipe.tags[0], recipe.servings ? `serves ${recipe.servings}` : undefined]
            .filter(Boolean)
            .join(' · ') || 'No tags yet'}
        </span>
      </div>
    </Link>
  );
}
